module.exports = __webpack_public_path__ + "img/breakfast_bistro_menu2.15630a71.png";